import { createSlice } from "@reduxjs/toolkit";

interface TreeViewState {
  searchTerm: string;
  expandedNodes: string[];
}
const initialState: TreeViewState = { searchTerm: '', expandedNodes: [] };
export const treeViewSlice = createSlice({
  name: 'treeView',
  initialState,
  reducers: {
    setSearchTerm: (state, action) => { state.searchTerm = action.payload; },
    setExpandedNodes: (state, action) => { state.expandedNodes = action.payload; },
  },
});
export const selectExpandedNodes = (state: { managementTree: TreeViewState }) => state.managementTree.expandedNodes;
export const selectSearchTerm = (state: { managementTree: TreeViewState }) => state.managementTree.searchTerm;

export const { setSearchTerm, setExpandedNodes } = treeViewSlice.actions;
export default treeViewSlice.reducer;